import { Button } from "primereact/button";

interface IButtonBarNavigate {
  cancel: () => void;
  back: () => void;
  next: () => void;
  shouldGoNext: boolean;
}

const ButtonsNavigate = ({
  cancel,
  back,
  next,
  shouldGoNext,
}: IButtonBarNavigate) => {
  return (
    <>
      <div className="flex">
        <div className="bottomButtonCancel">
          <Button
            label={"ANNULER"}
            type="button"
            onClick={() => {
                cancel()
            }}
            className="m-2 p-button-text p-button-sm"
          />
        </div>

        <div className="bottomButton">
          <Button
            label={"PRECEDENT"}
            type="button"
            onClick={() => {
                back()
            }}
            className="m-2 p-button-outlined p-button-sm"
          />
          {shouldGoNext && (
            <Button
              label={"SUIVANT"}
              type="button"
              onClick={() => {
                next();
              }}
              className="m-2 p-button-sm"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ButtonsNavigate;
